import { Controller } from 'stimulus';

const SLIDE_TRANSITION_DURATION = 250;

class GrowthReviews extends Controller {
  connect() {
    this.isSliding = false;

    if (window.matchMedia('(max-width: 1199px').matches) {
      this.enableReviewByIndex(0);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  calculateReviewHasScroll(reviewTarget) {
    const scrollContainer = reviewTarget.querySelector('.js-review-scroll-container');

    if (!scrollContainer) {
      return;
    }

    const { scrollHeight, clientHeight } = scrollContainer;

    if (scrollHeight > clientHeight) {
      reviewTarget.classList.add('has-scroll');
    } else {
      reviewTarget.classList.remove('has-scroll');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  onContentScroll(event) {
    const reviewTarget = event.currentTarget.closest('[data-target="growth-reviews.review"]');
    const scrollContainer = event.currentTarget;

    if (!scrollContainer || !reviewTarget) {
      return;
    }

    const { scrollHeight, clientHeight, scrollTop } = scrollContainer;

    if (scrollTop >= scrollHeight - clientHeight) {
      reviewTarget.classList.add('is-at-bottom');
    } else {
      reviewTarget.classList.remove('is-at-bottom');
    }
  }

  onToggle(event) {
    // Retrieve the review block that was clicked
    const reviewBlock = event.currentTarget.closest('[data-target="growth-reviews.review"]');

    // Retrieve the index of the review block that was clicked
    const index = parseInt(reviewBlock.getAttribute('data-index'), 10);

    // Check if the clicked review block is active, in that case we want to close all.
    const isClickedActive = reviewBlock.classList.contains('is-active');

    this.enableReviewByIndex(index, isClickedActive);
  }

  onToggleReview(event) {
    // Retrieve the index of the review block that was clicked
    const index = parseInt(event.currentTarget.getAttribute('data-index'), 10);

    // Check if the clicked review block is active, in that case we want to close all.
    const isClickedActive = event.currentTarget.classList.contains('is-active');

    this.enableReviewByIndex(index, isClickedActive);
  }

  enableReviewByIndex(index, shouldCloseAll = false) {
    if (this.isSliding) {
      return;
    }

    this.isSliding = true;

    const canCloseAll = window.matchMedia('(min-width: 1200px').matches;

    // Loop over every review
    this.reviewTargets.forEach((reviewTarget, reviewIndex) => {
      // Remove all possible active classes
      reviewTarget.classList.remove('is-active', 'is-prev-active');

      // If the clicked review block is active, we want to close all reviews, and thus not continue.
      if (shouldCloseAll && canCloseAll) {
        return;
      }

      // The current clicked review is the active one
      if (reviewIndex === index) {
        reviewTarget.classList.add('is-active');

        // Wait till the review has slide out, and then recalculate if the content can scroll.
        setTimeout(() => {
          this.calculateReviewHasScroll(reviewTarget);
        }, SLIDE_TRANSITION_DURATION + 100);

      // All previous reviews in the list get the prev-active class
      } else if (reviewIndex < index) {
        reviewTarget.classList.add('is-prev-active');
      }
    });

    // Wait for the slide transition to finish, and then unlock selecting other reviews.
    setTimeout(() => {
      this.isSliding = false;
    }, SLIDE_TRANSITION_DURATION);
  }
}

GrowthReviews.targets = [
  'review',
];

export default GrowthReviews;
